export const formatCouponStatus = (activation: string, expire: string): string => {
 const active = new Date(activation);
 const expiring = new Date(expire);

 const differenceInTime = active.getTime() - expiring.getTime();

 const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

 if (active.getTime() > expiring.getTime()) {
  return "expired";
 } else if (Math.abs(differenceInTime) < oneDayInMilliseconds) {
  return "expiring";
 } else {
  return "active";
 }
};

export const generateCouponCode = (): string => {
 const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
 let token = "";
 for (let i = 0; i < 6; i++) {
  token += characters.charAt(Math.floor(Math.random() * characters.length));
 }
 return token;
};
